import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow, MaskLines } from "./Reveal";
import { scrollToId } from "./smooth";
import { useT } from "../../lib/content";
import { imgSrc } from "../../data/artworks";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], [80, -80]);
  const t = useT();

  return (
    <section id="apropos" ref={ref} className="relative bg-[#E4ECE7] py-24 sm:py-32 lg:py-40 overflow-hidden" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative overflow-hidden aspect-[4/5] sm:aspect-[5/4] lg:aspect-[4/5] [clip-path:inset(0_0_0_0_round_0_0_220px_0)]">
            <motion.img style={{ y, scale: 1.18 }} src={imgSrc(t("about_image"))} alt="Christine dans son atelier"
              className="absolute inset-0 w-full h-full object-cover" data-testid="about-image" />
          </div>
          <motion.div style={{ y: y2 }} className="absolute -bottom-10 right-2 sm:right-8 w-[42%] p-2 bg-white shadow-[0_30px_60px_-25px_rgba(21,32,43,0.5)] rotate-[4deg]">
            <img src={imgSrc(t("about_image2"))} alt="Christine dans son atelier, entourée de ses toiles" className="w-full aspect-square object-cover" />
          </motion.div>
        </div>
        <div className="lg:col-span-5 lg:col-start-8">
          <Eyebrow>{t("about_eyebrow")}</Eyebrow>
          <h2 className="mt-5 f-display text-5xl sm:text-6xl font-light leading-[1] text-[#15202B]">
            <MaskLines inView lines={[t("about_title1"), <em key="e">{t("about_title2")}</em>]} />
          </h2>
          <Reveal className="mt-8 space-y-5 text-[#2E3B47] text-base sm:text-lg font-light leading-relaxed">
            <p>{t("about_p1")}</p>
            <p>{t("about_p2")}</p>
          </Reveal>
          <Reveal delay={0.1} className="mt-10 grid grid-cols-[96px_1fr] gap-5 items-center bg-[#F6F1E9] p-4" >
            <img src={imgSrc(t("easel_image"))} alt="Œuvre sur le chevalet" className="w-24 h-24 object-cover" data-testid="easel-artwork-image" />
            <p className="text-sm text-[#2E3B47]"><b className="font-medium text-[#15202B]">{t("easel_title")}</b> {t("easel_text")}</p>
          </Reveal>
          <div className="mt-8 flex flex-wrap gap-3">
            <button onClick={() => scrollToId("contact")} className="btn-ink" data-testid="easel-inquire-button">{t("about_cta")}</button>
            <a href={t("gallea_url")} target="_blank" rel="noopener noreferrer" className="btn-line" data-testid="about-gallea-link">Voir sur Gallea</a>
          </div>
        </div>
      </div>
    </section>
  );
};
